import { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import ParticipantTab from './components/tabs/EventResourcePersonTabs/ParticipantTab/ParticipantTab';
import ResourcePersonTab from './components/tabs/EventResourcePersonTabs/ResourcePerson/ResourcePersonTab';
import EventSelectedResourcePerson from './components/tabs/EventResourcePersonTabs/ResourcePersonSelected/EventSelectedResourcePersonTab';

function EventParticipants() {
  const [activeTab, setActiveTab] = useState('selected_resoures_person');
  const active_role = useSelector((state) => state.user?.user?.active_role);
  const completed = useSelector((state) => state.event.event.completed);

  let render = null;
  switch (activeTab) {
    case 'event.addResourcePerson':
      render = <ResourcePersonTab />;
      break;
    case 'selected_resoures_person':
      render = <EventSelectedResourcePerson />;
      break;
    case 'event.addParticipantAsResourceperson':
      render = <ParticipantTab />;
      break;
    default:
  }

  return (
    <div className="card">
      <div className="card-header">
        {(active_role === 'cd_admin' ||
          active_role === 'superuser' ||
          active_role === 'executive') &&
        !completed ? (
          <Tabs
            id="uncontrolled-tab-example"
            className=""
            activeKey={activeTab}
            onSelect={(tab) => setActiveTab(tab)}>
            {[
              'selected_resoures_person',
              'event.addResourcePerson',
              'event.addParticipantAsResourceperson'
            ].map((tab, index) => {
              return <Tab key={index} eventKey={tab} title={<FormattedMessage id={tab} />}></Tab>;
            })}
          </Tabs>
        ) : null}
      </div>
      <div className="card-body pt-0">
        {activeTab && (
          <></>
          // <div className=''>Filters</>
          // <h3>
          //   <FormattedMessage id={activeTab} />
          // </h3>
        )}
        {active_role ? render : <EventSelectedResourcePerson />}
      </div>
    </div>
  );
}

export default EventParticipants;
